package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A community feed post (`posts/{id}` — see `docs/DATA_MODEL.md`). Metro-scoped like listings;
 * `commentCount` is server-managed (rules lock it on author edits).
 */
data class Post(
    val id: String,
    val authorUid: String,
    val authorName: String,
    val type: PostType,
    val text: String,
    val metroId: String? = null,
    val commentCount: Int = 0,
    /** Server-maintained (Function recompute of `likes/` subcollection; rules lock client writes). */
    val likeCount: Int = 0,
    val createdAtMillis: Long? = null,
    /** Optional single photo (Storage `posts/{id}/`), stamped onto the doc after upload. */
    val photoUrl: String? = null,
)

enum class PostType { General, Question, Recommendation }
